import React, { Fragment } from "react"
import { Link, graphql } from "gatsby"
import { Row, Col, Divider, Tag } from "antd"
import SiteLayout from "../components/SiteLayout"
import CategoriesWidget from "../components/CategoriesWidget"
import RecentCommentsWidget from "../components/RecentCommentsWidget"
import RecentPostsWidget from "../components/RecentPostsWidget"
import PostEntryMeta from "../components/PostEntryMeta"
import Seo from "../components/Seo"
import moment from "moment/moment"

const renderTermNodes = (nodes, title) => (
  <div>
    {title}
    {` `}
    {nodes.map(term => (
      <Tag>{term.name}</Tag>
    ))}
  </div>
)

const renderTerms = (categoryNodes = [], tagNodes = []) => (
  <Fragment>
    <Divider />
    {categoryNodes ? renderTermNodes(categoryNodes, `Categories: `) : null}
    {tagNodes && tagNodes.length ? renderTermNodes(tagNodes, `Tags: `) : null }
  </Fragment>
)

const Post = props => {
  const {
    location,
    data: {
      wpgraphql: { post },
    },
  } = props
  const { title, content } = post
  return (
    <SiteLayout location={location}>
      <Seo title={`${post.title}`} />
      <Row type="flex" gutter={24}>
        <Col xs={24} md={24}>
          <h1>{title}</h1>
          <p>
          {moment(post.date).format(`MMM Do YY`)} by <Link to={`/author/${post.author.slug}`}>{post.author.name}</Link>
          </p>
          <Divider />
          <Row type="flex" justify="space-around" gutter={24}>
{/*
            <Col xs={24} md={6}>
              <PostEntryMeta post={post} />
            </Col>
*/}
            <Col xs={24} md={24}>
              {!!post.featuredImage && <img src={post.featuredImage.sourceUrl} />}
              <div dangerouslySetInnerHTML={{ __html: content }} />
              {post.categories.nodes.length || post.tags.nodes.length
                ? renderTerms(post.categories.nodes, post.tags.nodes)
                : null}
            </Col>
          </Row>
        </Col>
{/*
        <Col xs={24} md={8}>
          <CategoriesWidget />
        </Col>
*/}
      </Row>
    </SiteLayout>
  )
}

export default Post

export const pageQuery = graphql`
  query GET_POST($id: ID!) {
    wpgraphql {
      post(id: $id) {
        title
        content
        uri
        featuredImage {
          sourceUrl
        }
        author {
          name
          slug
          avatar {
            url
          }
        }
        tags {
          nodes {
            name
            link
          }
        }
        categories {
          nodes {
            name
            link
          }
        }
      }
    }
  }
`
